import { render, staticRenderFns } from "./shift-staffing.vue?vue&type=template&id=849aa292&scoped=true"
import script from "./shift-staffing.vue?vue&type=script&lang=js"
export * from "./shift-staffing.vue?vue&type=script&lang=js"
import style0 from "./shift-staffing.vue?vue&type=style&index=0&id=849aa292&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "849aa292",
  null
  
)

export default component.exports